module.exports = __webpack_public_path__ + "static/media/madequimica_unica.a84f043d.webp";